export default [
  {
    date: new Date(2026, 11, 4),
    rooms: [
      {
        name: "Nimman 1",
        videos: [
          {
            time: "08.30 - 10.00",
            name: "Common Nephrology IPD Consultations",
            file: "N1-11-s1.mp4",
          },
          {
            time: "10.30 - 11.30",
            name: "The Current Practice in CKD",
            file: "N1-11-s2.mp4",
          },
          {
            time: "11.35 - 12.25",
            name: "Educational Symposia 1 - Black and White Spectrum: The Continuum of Kidney Care",
            file: "ES1.mp4",
          },
          {
            time: "12.40 - 13.30",
            name: "Educational Symposia 3 - Optimizing Strategies for Hyponatremia: Where Clinical Impact Meets Economic Value",
            file: "ES3.mp4",
          },
          {
            time: "13.40 - 14.40",
            name: "Current Management in Glomerular Disease",
            file: "N1-11-s3.mp4",
          },
          {
            time: "15.00 - 16.30",
            name: "What's Hot & What's New?",
            file: "N1-11-s4.mp4",
          },
        ],
      },
      {
        name: "Nimman 3",
        videos: [
          {
            time: "08.30 - 10.00",
            name: "Game Changers for Dialysis Management in 2026",
            file: "N3-11-s1.mp4",
          },
          {
            time: "10.30 - 11.30",
            name: "Nephrology Consultations for Critically Ill Patients",
            file: "N3-11-s2.mp4",
          },
          {
            time: "11.35 - 12.25",
            name: "Educational Symposia 2 - Kidney Road Map: Choosing ONE Champion",
            file: "ES2.mp4",
          },
          {
            time: "12.40 - 13.30",
            name: "Educational Symposia 4 - คนละครึ่งมั้ย? คิดถึงไต ให้ถึงใจ มากกว่าเดิม",
            file: "ES4.mp4",
          },
          {
            time: "13.40 - 14.40",
            name: "Healthy living with CKD",
            file: "N3-11-s3.mp4",
          },
          {
            time: "15.00 - 16.30",
            name: "Practical Point of Dialysis in Difficult Patients",
            file: "N3-11-s4.mp4",
          },
        ],
      },
    ],
  },
  {
    date: new Date(2026, 11, 5),
    rooms: [
      {
        name: "Nimman 1",
        videos: [
          {
            time: "08.30 - 10.00",
            name: "Management of Diabetic Kidney Disease: What's Next?",
            file: "N1-12-s5.mp4",
          },
          {
            time: "10.30 - 11.30",
            name: "Cardiovascular disease among CKD patients",
            file: "N1-12-s6.mp4",
          },
          {
            time: "11.35 - 12.25",
            name: "Educational Symposia 5 - PROVEN CARE, ONE STANDARD: TACROLIMUS THERAPY FROM AUTOIMMUNITY TO TRANSPLANTATION",
            file: "ES5.mp4",
          },
          {
            time: "12.40 - 13.30",
            name: "Educational Symposia 7 - Shingles Talks: Optimizing Shingles Vaccination in Adults 50+ and CKD Population",
            file: "ES7.mp4",
          },
          {
            time: "13.40 - 15.10",
            name: "Recent Clinical Trials That Will Impact Your Practice",
            file: "N1-12-s7.mp4",
          },
        ],
      },
      {
        name: "Nimman 3",
        videos: [
          {
            time: "08.30 - 10.00",
            name: "Common Challenges in Dialysis Patients: Case Studies and Audience Interaction",
            file: "N3-12-s5.mp4",
          },
          {
            time: "10.30 - 11.30",
            name: "An Ounce of Prevention is Worth a Pound of Cure",
            file: "N3-12-s6.mp4",
          },
          {
            time: "11.35 - 12.25",
            name: "Educational Symposia 6 - Kidney Protected, Anemia Corrected, Phosphate Controlled",
            file: "ES6.mp4",
          },
          {
            time: "12.40 - 13.30",
            name: "Educational Symposia 8 - Integrated Approaches to Glomerular Disease and Kidney Transplantation: Evidence, and Future Directions",
            file: "ES8.mp4",
          },
          {
            time: "13.40 - 15.10",
            name: "Standing Together: Supporting Our Patients in Every Way",
            file: "N3-12-s7.mp4",
          },
        ],
      },
    ],
  },
];
